import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { toastError, toastSuccess } from "../../../../../utils/constants";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import Modal from "react-modal";
import { data } from "jquery";
import {
  submitKeywordsAndInformation_action,
  getKeywordsAndInformationList_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/keyword_and_information_action/keyword_and_information_action";
import moment from "moment";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

class KeywordsInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      keywordsList: [],
      is_delete: false,
      keyword: "",
      HSNCode: "",
      listLength: 0,
      KeywordID: "",
      ManualFormID: 6,
      StatusID: "",
      DeadlineDate: "",
      currentDate: moment().format("DD-MM-YYYY"),
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      is_View: false
    };
    this.OnAddKeyword = this.OnAddKeyword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getKeywordsListDetails = this.getKeywordsListDetails.bind(this);
    this.deleteKeywordInformationList = this.deleteKeywordInformationList.bind(this);

    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.handleSubmit()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.setState({
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
      StatusID:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.StatusID != ""
          ? this.props.location.state.StatusID
          : "",
      is_View:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1,
    });
    setTimeout(() => {
      this.getKeywordsListDetails();
    }, 100);
  }

  getKeywordsListDetails() {
    this.setState({ isLoading: true });
    this.props
      .getKeywordsAndInformationList_action()
      .then((data) => {
        if (data.error != 1) {
          console.log("done");

          this.setState({ isLoading: false });

          if (data.data != "") {
            data.data.map((data, i) => {
              data.is_delete = false;
              data.ID = i++;
            });
            console.log("keywordsList *****", data.data);
            this.setState({ keywordsList: data.data });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  chehckedKeywordInformationList(e, index) {
    const { keywordsList } = this.state;
    const pList = [...keywordsList];
    const event = e.target.checked;

    if (event == true) {
      pList.forEach((data, i) => {
        if (index === data.ID) {
          data.is_delete = true;
        }
      });
      console.log("pList", pList);
      this.setState({
        keywordsList: pList,
      });
    } else {
      pList.forEach((data, i) => {
        if (index === data.ID) {
          data.is_delete = false;
        }
      });
    }
    this.setState({
      keywordsList: pList,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { KeywordID, ManualFormID, keywordsList } = this.state;

    const newArray = [];

    keywordsList.map((data, i) => {
      newArray.push({
        Keywords: data.Keywords,
        hsncode: data.HSNCode,
      });
    });

    var Keyword = false;
    const keyword = keywordsList.every((item) => item.Keywords != "");
    if (keyword) {
      Keyword = true;
    } else {
      Keyword = false;
    }

    var Hsncode = false;
    const hcncode = keywordsList.every((item) => item.HSNCode != "");
    if (hcncode) {
      Hsncode = true;
    } else {
      Hsncode = false;
    }

    this.setState({ isLoading: true });
    if (Keyword) {
      if (Hsncode) {
        const KeywordID = this.props.location.state?.KeywordID || null;
        const ServiceID = this.props.location.state?.ServiceID || null;
        const VendorDetails = this.props.location.state?.VendorDetails || {};
        this.props
          .submitKeywordsAndInformation_action(
            KeywordID,
            ManualFormID,
            newArray,
            ServiceID,
            VendorDetails
          )
          .then((data) => {
            if (data.error != 1) {
              console.log("done");
              // toastSuccess("Record Added Successfully")
              this.setState({ isLoading: false });
              toastSuccess(
                this.state.StatusID == 0
                  ? "Keywords And Information Form Submitted Successfully"
                  : "Keywords And Information Form Updated Successfully"
              );
              setTimeout(() => {
                this.props.navigate("/manualForms");
              }, 2000);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastError("Plase enter HSN code");
        this.setState({ isLoading: false });
      }
    } else {
      toastError("Plase enter keywords");
      this.setState({ isLoading: false });
    }
  }

  deleteKeywordInformationList() {
    const { keywordsList } = this.state;
    console.log("keywordsList", keywordsList);

    var is_delete = false;
    const keywordDelete = keywordsList.every((item) => item.is_delete != true);
    if (keywordDelete) {
      is_delete = true;
      console.log("**:::::::::::::true", is_delete);
    } else {
      is_delete = false;
      console.log("**:::::::::::::false", is_delete);
    }
    if (is_delete == false) {
      var list = keywordsList.filter((data) => data.is_delete != true);
      toastSuccess("data deleted successfully!");
      this.setState({
        keywordsList: list,
      });
    } else {
      toastError("please select atleast one entry!");
    }
  }

  OnAddKeyword(e) {
    e.preventDefault();
    console.log(this.state.listLength);
    const { keywordsList } = this.state;
    var id = keywordsList.length + 1;
    var map = {
      ID: id,
      is_delete: false,
      Keywords: "",
      HSNCode: "",
    };
    keywordsList.push(map);
    this.setState({ keywordsList: keywordsList });
    console.log(this.state.keywordsList);
  }

  enterKeywords(e, index) {
    const { keywordsList } = this.state;
    const list = [...keywordsList];
    for (let i = 0; i < list.length; i++) {
      if (i == index) {
        list[i]["Keywords"] = e.target.value;
      }
    }
    this.setState({
      keywordsList: list,
    });
  }

  enterHCNcode(e, index) {
    const { keywordsList } = this.state;
    const list = [...keywordsList];
    for (let i = 0; i < list.length; i++) {
      if (i == index) {
        list[i]["HSNCode"] = e.target.value;
      }
    }
    this.setState({
      keywordsList: list,
    });
  }

  handleCancel() {
    window.history.back();
  }

  render() {
    const { isLoading, keywordsList, DeadlineDate, StatusID, currentDate, isHideSection, isOpenConfirmationModal, is_View } =
      this.state;
    const isDeadlinePassed =
      DeadlineDate &&
      moment(DeadlineDate, "DD-MM-YYYY") &&
      moment(currentDate, "DD-MM-YYYY").isAfter(moment(DeadlineDate, "DD-MM-YYYY"));

    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {!isHideSection && (
          <>
            <ExhibitorHeader />
            <ExhibitorDrawer />
          </>
        )}
        <div className={!isHideSection ? " with-dr-container " : ""}>
          <div className="width-dr-nav">
            {!isHideSection && (
              <div className="row mt-4">
                <ExhibitorTopMenu />
              </div>
            )}
            <div className="">
              <div className="row mt-3">
                <div class="col-xl-12 p-0">
                  <div class="card rounded-0 border shadow-none mb-0">
                    <div class="card-header " style={{ paddingleft: "7px !important" }}>
                      <div class="col-12">
                        <h3 class="card-title mt-2" style={{ fontsize: "15px", float: "left" }}>
                          Keywords Information
                        </h3>
                      </div>
                    </div>
                    {!isHideSection && (
                      <div className="row mt-1" style={{ paddingLeft: "1.5rem" }}>
                        <h6 className="mt-2 ">
                          Keyword Information{" "}
                          <span className="text-danger">
                            {" "}
                            Last Date Of Submission -{" "}
                            {this.props.location?.state?.ActualDeadline
                              ? moment(this.props.location.state.ActualDeadline).format(
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </span>
                        </h6>
                      </div>
                    )}
                    <div class="card-body pt-2 px-4">
                      {!isHideSection && (
                        <button
                          type="button"
                          class="btn btn-aqua rounded-1"
                          style={{ float: "right" }}
                          disabled={isDeadlinePassed}
                          onClick={(e) => this.OnAddKeyword(e)}
                        >
                          Add Keyword
                        </button>
                      )}
                      <div class="table-responsive">
                        <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                          <thead>
                            <tr>
                              <th width="50px" class="text-center">
                                Sr No
                              </th>
                              <th style={{ width: "70px" }} class="text-center">
                                Delete
                              </th>
                              <th>KEYWORDS</th>
                              <th>HSN CODE</th>
                            </tr>
                          </thead>
                          <tbody>
                            {keywordsList.length > 0 ? (
                              keywordsList.map((data, i) => (
                                <tr key={data.ID}>
                                  <td class="text-center" style={{ lineHeight: "30px" }}>
                                    {i + 1}
                                  </td>
                                  <td class="text-center">
                                    <input
                                      type="checkbox"
                                      style={{ width: "50px" }}
                                      class="example-checkbox mt-2 p-0 m-0"
                                      value={data.is_delete}
                                      disabled={isDeadlinePassed || is_View}
                                      // placeholder="3.7.22"

                                      onChange={(e) =>
                                        this.chehckedKeywordInformationList(e, data.ID)
                                      }
                                    />
                                  </td>
                                  <td className="p-1">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={data.Keywords}
                                      disabled={isDeadlinePassed || is_View}
                                      onChange={(e) => this.enterKeywords(e, i)}
                                    />
                                  </td>
                                  <td className="p-1">
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={data.HSNCode}
                                      disabled={isDeadlinePassed || is_View}
                                      onChange={(e) => this.enterHCNcode(e, i)}
                                    />
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={10} className="text-center">
                                  Record not available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {!isHideSection && (
                <div className="row">
                  {isDeadlinePassed && (
                    <span className="text-danger">
                      THE DEADLINE TO FILL OUT THE FORM HAS PASSED.
                    </span>
                  )}
                </div>
              )}
              <div class="d-flex justify-content-end mt-0">
                {!isHideSection && (
                  <>
                    <button
                      type="button"
                      class="btn btn-aqua rounded-1"
                      disabled={isDeadlinePassed}
                      style={{ marginRight: "10px" }}
                      // onClick={this.handleSubmit}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to  ${this.state.StatusID == 0 ? "Submit" : "Update"}?`, buttonName: this.state.StatusID == 0 ? "Submit" : "Update", action: 0 }, popArg: [] })}
                    >
                      {this.state.StatusID == 0 ? "Submit" : "Update"}
                    </button>
                    <button
                      type="button"
                      class="btn btn-aqua rounded-1"
                      disabled={isDeadlinePassed}
                      onClick={this.deleteKeywordInformationList}
                    >
                      Delete
                    </button>
                  </>
                )}
                {!isHideSection && <button
                  className="btn rounded-1 btn-gray"
                  style={{ marginLeft: "10px" }}
                  onClick={() => this.handleCancel()}
                >
                  Back
                </button>}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(null, { submitKeywordsAndInformation_action, getKeywordsAndInformationList_action })(
    KeywordsInformation
  )
);
